<template>
    <div class="mainBody">
        <el-form ref="formValidate" :model="model" :rules="rules" label-width="320px">
            <el-form-item label="测试模式：" prop="dev_model">
                <el-radio v-model="model.dev_model" label="0">线上模式</el-radio>
                <el-radio v-model="model.dev_model" label="1">测试模式</el-radio>
            </el-form-item>
            <el-form-item label="审核模式：" prop="sh_model">
                <el-radio v-model="model.sh_model" label="0">线上模式</el-radio>
                <el-radio v-model="model.sh_model" label="1">审核模式</el-radio>
            </el-form-item>
            <el-form-item label="推送限制：" prop="sh_model">
                <el-radio v-model="model.limit_send" label="0">不限制</el-radio>
                <el-radio v-model="model.limit_send" label="1">限制</el-radio>
            </el-form-item>
            <el-form-item label="活跃用户(72h)：" prop="sh_model">
                <span>{{model.active_member_count}}</span>
            </el-form-item>
            <!-- <el-form-item label="App用户验证：" prop="sh_model">
                <el-radio v-model="model.app_check_uid" label="0">不验证</el-radio>
                <el-radio v-model="model.app_check_uid" label="1">验证</el-radio>
            </el-form-item> -->
            <el-form-item label="平台地址：" prop="systemUrl">
                <el-input v-model="model.systemUrl" style="width: 680px" ></el-input>
            </el-form-item>
            <!-- <el-form-item label="图片地址：" prop="imgUrl">
                <el-input v-model="model.imgUrl" style="width: 680px" ></el-input>
            </el-form-item> -->
            <el-form-item label="静态路径：" prop="staticPath">
                <el-input v-model="model.staticPath" style="width: 680px" ></el-input>
            </el-form-item>
            <el-form-item label="下载路径：" prop="downloadPath">
                <el-input v-model="model.downloadPath" style="width: 680px" ></el-input>
            </el-form-item>
            <el-form-item label="客服微信：" prop="kefu_qrcode">
                <el-input v-model="model.kefu_qrcode" style="width: 680px" ></el-input>
            </el-form-item>
            <el-form-item label="直播状态：" prop="is_living">
                <el-select v-model="model.is_living" clearable placeholder="请选择">
                    <el-option v-for="item in enuObj('living_type')" :key="'living_type'+item.key" :label="item.title" :value="item.key"> </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="直播封面：" prop="living_cover" class="tipsitem">
                <el-upload
                    class="img-uploader"
                    name="upFile"
                    :action="uploadAction"
                    :data="uploadData"
                    accept="image/png, image/gif, image/jpg, image/jpeg"
                    :show-file-list="false"
                    :on-success="handleUploadSuccess"
                    :before-upload="beforeUpload">
                    <img v-if="model.living_cover" :src="model.living_cover" class="upImg" style="width: 250px;height: 176px">
                    <i v-else class="el-icon-plus img-uploader-icon" style="width: 250px;height: 176px;line-height: 176px"></i>
                </el-upload>
                <span class="tips">建议尺寸：500px * 352px</span>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="handleSubmit" size="medium">保 存</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import { getSysConfig, saveConfig } from '@/api/sysconfig'
import { getEnuData } from '@/api/common'
import config from '@/config'

export default {
    name: "sysConfig",
    data() {
        return {
            model: {
                dev_model: '0',
                sh_model: '0',
                systemName: '',
                systemUrl: '',
                imgUrl: '',
                staticPath: '',
                downloadPath: '',
                limit_send: '0',
                app_check_uid: '0',
                is_living: '0',
                living_cover: '',
                active_member_count: 0,
                kefu_qrcode: '',
            },
            rules: {
                systemUrl: [
                    {required: true, message: '平台不能为空', trigger: 'blur'},
                ],
                imgUrl: [
                    {required: true, message: '图片不能为空', trigger: 'blur'},
                ],
                staticPath: [
                    {required: true, message: '静态路径不能为空', trigger: 'blur'},
                ],
                downloadPath: [
                    {required: true, message: '下载路径不能为空', trigger: 'blur'},
                ],
            },
            enu_obj: {},
            enu_name: ['living_type'],            
            uploadAction: config.uploadAction,
            uploadData: {
                folder: "product",
            },
        }
    },
    mounted(){
        this.getData()
    },
    methods: {
        getData(){
            if (this.enu_name.length > 0) {
                this.initEnuData();
            }
            getSysConfig().then(res=>{
                if(res.code ==1){
                    let config = JSON.parse(res.data.config_str)
                    this.model.dev_model = config.dev_model
                    this.model.sh_model = config.sh_model
                    this.model.systemName = config.systemName
                    this.model.systemUrl = config.systemUrl
                    this.model.imgUrl = config.imgUrl
                    this.model.staticPath = config.staticPath
                    this.model.downloadPath = config.downloadPath
                    this.model.limit_send = config.limit_send+""
                    this.model.app_check_uid = config.app_check_uid
                    this.model.is_living = config.is_living
                    this.model.living_cover = config.living_cover
                    this.model.kefu_qrcode = config.kefu_qrcode
                    this.model.active_member_count = res.data.active_member_count
                }
            })
        },
        initEnuData() {
            getEnuData(this.enu_name).then(res => {
                if (res.code == 1) {
                    let enu_array = res.data
                    for (let i = 0; i < enu_array.length; i++) {
                        let e_obj = enu_array[i];
                        let vals = e_obj.values;
                        let diss = e_obj.displays;
                        let e_Map_Obj = {};
                        let e_Map_Obj1 = [];
                        for (let j = 0; j < (vals.length < diss.length ? vals.length : diss.length); j++) {
                            e_Map_Obj[vals[j]] = diss[j]
                            e_Map_Obj1[j] = vals[j] + ',' + diss[j]
                        }
                        this.enu_obj[e_obj.name] = e_Map_Obj;
                        this.enu_obj[e_obj.name + 'order_data'] = e_Map_Obj1;
                    }
                    return
                }
            })
        },
        handleSubmit(){
            this.$refs['formValidate'].validate((valid) => {
                if (valid) {
                    this.model.limitF = this.model.limitF+""
                    let config_str = JSON.stringify(this.model)
                    saveConfig(config_str).then(res=>{
                        if(res.code ==1){
                            this.$msgs("保存成功！");
                        }else{
                            this.$msg(res.msg)
                        }
                    })
                }
            })
        },
        enuObj(enum_name) {
            let enuInfo = this.enu_obj[enum_name + 'order_data'];
            let arr = [];
            if (enuInfo != undefined) {
                var values = Object.values(enuInfo);
                for (let i = 0; i < values.length; i++) {
                    let str = values[i].split(",")
                    let temp = {};
                    temp["key"] = str[0]
                    temp["title"] = str[1]
                    arr.push(temp)
                }
            }
            return arr
        },
        handleUploadSuccess(res, file){
            if(res.code ==1){
                this.model.living_cover = res.data[0]
            }else{
                this.$msg(res.msg)
            }
        },
        beforeUpload(file){
            const isLt2M = file.size / 1024 / 1024 < 1;
            if (!isLt2M) {
                this.$message.error('上传图片大小不能超过 1MB!');
            }
            return isLt2M;
        },
    }
}
</script>